module.exports = __webpack_public_path__ + "img/35Kennedy.dfdaa2d4.png";